/* remove '/api' string from fetched documents path to avoid doubling it */
export const documentsParser = data =>
  data.map(item => {
    return {
      ...item,
      path: item.link.replace('/api', ''),
    };
  });
